import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import {AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW0B00Component } from './kymw0b00.component';
import { GetKYMW0B00InitService } from './api-services/get_kymw0B00_init.service';

/**
 * 画像検索画面 モジュール設定クラス
 *
 * @export KYMW0B00Module
 * @class KYMW0B00Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW0B00Component,
  ],
   providers: [
    GetKYMW0B00InitService,
  ],
})
export class KYMW0B00Module {
}
